import React, { useState } from 'react';
import { BriefcaseIcon, HomeIcon, PencilIcon, PhoneIcon, PlusIcon, Trash2Icon } from 'lucide-react';
import { SAVED_ADDRESSES } from '../../data/account';
import { SavedAddress } from '../../types';
export function AddressesTab() {
  const [addresses, setAddresses] = useState<SavedAddress[]>(SAVED_ADDRESSES);
  return <div data-id="element-25" data-mp="1b0cw2hjlcex5">
      <div className="space-y-4" data-id="element-26" data-mp="1ay0dq39x82jk">
        {addresses.map(item => {
        const Icon = item.label === 'Casa' ? HomeIcon : BriefcaseIcon;
        return <article key={item.id} className="border border-white/10 bg-ink-800 p-5 transition-colors hover:border-pink-500/40" data-id="element-27" data-mp="23nh836h3ptif">
              <div className="flex flex-wrap items-start justify-between gap-4" data-id="element-28" data-mp="1unkldae9v4q0">
                <div className="min-w-0" data-id="element-29" data-mp="ea3xizieb98v">
                  <div className="flex items-center gap-3" data-id="element-30" data-mp="e919czcgjkwn">
                    <Icon className="h-4 w-4 shrink-0 text-pink-500" data-id="element-31" data-mp="j8nndb04156i" />
                    <h3 className="font-display text-xl uppercase leading-none tracking-wide text-white" data-id="element-32" data-mp="j6ufjsdrgewx">
                      {item.label}
                    </h3>
                    {item.primary && <span className="bg-pink-500 px-2 py-1 text-[10px] font-bold uppercase tracking-[0.14em] text-white" data-id="element-33" data-mp="30mirce64450n">
                        Principal
                      </span>}
                  </div>
                  <p className="mt-3 max-w-xl text-sm leading-relaxed text-white/50" data-id="element-34" data-mp="3ohliwtwawmkt">
                    {item.address}
                  </p>
                  <p className="mt-2 flex items-center gap-2 text-xs text-white/35" data-id="element-35" data-mp="3jiqnmsh5d5jt">
                    <PhoneIcon className="h-3.5 w-3.5" data-id="element-36" data-mp="217itgo8db97" />
                    {item.phone}
                  </p>
                </div>

                <div className="flex items-center gap-2" data-id="element-37" data-mp="3tb657ooj7s46">
                  <button type="button" aria-label={`Editar dirección ${item.label}`} className="border border-white/10 p-2.5 text-white/60 transition-colors hover:border-pink-500 hover:text-pink-500" data-id="element-38" data-mp="b407rd9xxavv">
                    <PencilIcon className="h-3.5 w-3.5" data-id="element-39" data-mp="j33ka1j0vhze" />
                  </button>
                  <button type="button" onClick={() => setAddresses(prev => prev.filter(a => a.id !== item.id))} aria-label={`Eliminar dirección ${item.label}`} className="border border-white/10 p-2.5 text-white/60 transition-colors hover:border-red-500 hover:text-red-500" data-id="element-40" data-mp="o2g40delk8xr">
                    <Trash2Icon className="h-3.5 w-3.5" data-id="element-41" data-mp="16uiq44a0chfe" />
                  </button>
                </div>
              </div>
            </article>;
      })}
      </div>

      <button type="button" className="mt-5 flex w-full items-center justify-center gap-2 border border-pink-500 py-4 text-[11px] font-bold uppercase tracking-[0.18em] text-pink-500 transition-colors hover:bg-pink-500 hover:text-white" data-id="element-42" data-mp="38ldlww47sgm4">
        <PlusIcon className="h-4 w-4" data-id="element-43" data-mp="1uqx7amayiq4t" />
        Agregar nueva dirección
      </button>
    </div>;
}